const PublicProfileSectionHeaderSkeleton = () => {
  return (
    <div className="relative flex w-full items-start justify-start bg-background py-2">
      <div className="flex w-full items-start justify-start gap-4 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div className="h-10 w-24 animate-pulse rounded bg-gray-200" />
        <div className="h-10 w-24 animate-pulse rounded bg-gray-200" />
        <div className="h-10 w-32 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  )
}

export default PublicProfileSectionHeaderSkeleton
